import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbActionMenuItem";
export class AbActionMenuSubmenu extends AbActionMenuItem {
  constructor(id, icon, label, actions, enabled = true, dataTestId) {
    super(icon, label, null, enabled, null, dataTestId);
    _defineProperty(this, "_actions", void 0);
    _defineProperty(this, "_id", void 0);
    this._id = id;
    this._actions = actions;
  }
  get id() {
    return this._id;
  }
  get actions() {
    return this._actions.slice();
  }
}
//# sourceMappingURL=AbActionMenuSubmenu.js.map
